<template>
	<section>
		<ButtonBack />
		<el-row>
			<el-col :sm="12">
				<h1>Beschwerden</h1>
			</el-col>
			<el-col :sm="12" class="flex flex--justifyend">
				<RouterLink :to="'/beschwerde-anlegen'" class="el-button el-button--danger is-round" :title="'Neue Beschwerde anlegen'">
					<el-icon><Plus /></el-icon>Neue Beschwerde
				</RouterLink>
			</el-col>
		</el-row>

		<h2>Filter</h2>

		<TheForm :model="request" :rules="rules" :id="id" ref="formRef" :persistForm="true" formNamespace="beschwerdenFilter" :autoSave="true">
			<el-row>
				<el-form-item label="Freitextsuche" prop="searchTerm" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-input v-model="request.searchTerm" placeholder="Suche" clearable />
				</el-form-item>

				<el-form-item label="Kategorie" prop="category" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-select v-model="request.category" placeholder="Alle">
						<el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item" />
					</el-select>

					<!-- <v-select
						v-model="request.category"
						label="label"
						:options="categoryOptions"
						:clearable="false"
						:searchable="false"
						:placeholder="'Alle'"
					/> -->
				</el-form-item>
			</el-row>

			<el-row>
				<el-col :sm="12" :xs="24">
					<el-row>
						<el-form-item label="Medium" prop="medium" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.medium" placeholder="Alle" :automatic-dropdown="true" :teleported="false">
								<el-option v-for="item in mediaOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
						<el-form-item label="Anhang" prop="hasAttachments" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.hasAttachments" placeholder="Alle">
								<el-option v-for="item in attachmentOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
					</el-row>
				</el-col>

				<el-col :sm="12" :xs="24">
					<el-row>
						<el-form-item label="Status" prop="states" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.states" placeholder="Alle">
								<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
						<el-form-item label="Veröffentlicht" prop="isPublished" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.isPublished" placeholder="Alle">
								<el-option v-for="item in isPublicOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
					</el-row>
				</el-col>
			</el-row>

			<el-row>
				<el-form-item label="Zeitraum (Erstellung)" prop="timePeriod" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-checkbox-group v-model="selectedTimePeriod" placeholder="Alle">
						<el-checkbox
							v-for="item in timePeriodOptions"
							:key="item.value"
							:value="item.value"
							:border="true"
							@change="() => handleClickOptionWrapper(item)"
						>
							{{ item.label }}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-col :sm="4" :xs="24"></el-col>
				<el-form-item label="" prop="dateRange" class="el-col el-col-24 el-col-sm-8 el-col-xs-24">
					<div class="datepicker-range__labels">
						<label class="el-form-item__label">Von</label>
						<label class="el-form-item__label">Bis</label>
					</div>
					<el-date-picker
						v-model="dateRange"
						type="daterange"
						:format="'DD.MM.YYYY'"
						range-separator=""
						:clearable="true"
						start-placeholder="TT.MM.JJJJ"
						end-placeholder="TT.MM.JJJJ"
					/>
				</el-form-item>
			</el-row>
			<el-row class="button-panel">
				<TheButton
					type="danger"
					@buttonclick="
						tablePage = 0;
						doSearch();
					"
					isSubmit
					>Anwenden</TheButton
				>
				<TheButton type="default" @buttonclick="resetSearch">
					<el-icon><Close /></el-icon>
					Filter zurücksetzen
				</TheButton>
			</el-row>
		</TheForm>
	</section>

	<div class="bg--white">
		<section id="searchresults">
			<h2>Beschwerden ({{ $getCountErgebnisseLabel(complaintsTotalCount) }})</h2>
			<ComplaintsTable
				:tableData="filteredComplaints"
				:loading="complaintsTableLoading"
				:totalCount="complaintsTotalCount"
				@loadNextPage="loadNextPage"
			/>
		</section>
	</div>
</template>

<script lang="ts">
import { searchComplaints } from '@/requests/searches';
import { ComplaintResponse, SearchComplaintRequest } from '@/types/types';
import { handleClickTimePeriodOptionCheckbox, handleSearchDateRangeChange, prepareSearchRequest } from '@/utils/search/searchUtils';
import { validateForm, resetForm } from '@/utils/functions';
import { Close, Plus } from '@element-plus/icons-vue';
import type { FormInstance } from 'element-plus';
import { defineComponent, ref } from 'vue';
import ButtonBack from '../components/buttons/ButtonBack.vue';
import ComplaintsTable from '../components/tables/ComplaintsTable.vue';
import TheButton from '../components/TheButton.vue';
import TheForm from '../components/TheForm.vue';
import { returnFormOptions } from '../utils/formOptions.js';

interface SearchComplaintsData {
	request: SearchComplaintRequest;
	rules: Object;
	id: string;
	dateRange: string[] | null;
	selectedTimePeriod: any[];
	tablePage: number;
	itemsPerPage: number;
	filteredComplaints: ComplaintResponse[];
	complaintsTotalCount: number;
	complaintsTableLoading: boolean;
}

export default defineComponent({
	name: 'BeschwerdenView',
	data(): SearchComplaintsData {
		return {
			request: {
				searchTerm: '',
				medium: null,
				category: null,
				hasAttachments: null,
				states: null,
				isPublished: null,
				fromDate: null,
				toDate: null,
			},
			rules: {},
			id: 'searchForm',
			dateRange: null,
			selectedTimePeriod: [],
			tablePage: 0,
			itemsPerPage: 14,
			filteredComplaints: [],
			complaintsTotalCount: 0,
			complaintsTableLoading: false,
		};
	},
	setup() {
		const formRef = ref<FormInstance>();

		return {
			formRef,
		};
	},
	components: {
		ButtonBack,
		TheButton,
		TheForm,
		Plus,
		Close,
		ComplaintsTable,
	},
	computed: {
		categoryOptions() {
			return returnFormOptions('complaintAndCaseCategories', false, true);
		},
		mediaOptions() {
			return returnFormOptions('media', false, true);
		},
		attachmentOptions() {
			return returnFormOptions('attachment', false, true);
		},
		statusOptions() {
			return returnFormOptions('complaintStateOptions', false, true);
		},
		isPublicOptions() {
			return returnFormOptions('isPublic', false, true);
		},
		timePeriodOptions() {
			return returnFormOptions('timePeriod');
		},
	},
	methods: {
		handleClickOptionWrapper(item) {
			const { newSelectedTimePeriod, newTimePeriodOptions, newDateRange } = handleClickTimePeriodOptionCheckbox(
				item,
				this.selectedTimePeriod,
				this.timePeriodOptions,
			);

			this.selectedTimePeriod = newSelectedTimePeriod;
			this.timePeriodOptions = newTimePeriodOptions;
			this.dateRange = newDateRange;
		},
		resetSearch() {
			resetForm(this.formRef, this.id);
			this.dateRange = null;
			this.tablePage = 0;
			this.doSearch();
		},
		async doSearch() {
			const isValid = await validateForm(this.formRef, this.id);
			if (!isValid) return;

			this.complaintsTableLoading = true;
			const searchRequest = prepareSearchRequest(this.request);

			if (searchRequest.states) {
				searchRequest.states = [searchRequest.states];
			}

			const searchResult = await searchComplaints(searchRequest, this.tablePage, this.itemsPerPage);

			if (searchResult.success) {
				this.complaintsTotalCount = searchResult.data.totalCount;
				if (this.tablePage === 0) {
					this.filteredComplaints = searchResult.data.items;
				} else {
					this.filteredComplaints = [...this.filteredComplaints, ...searchResult.data.items];
				}
			} else {
				this.filteredComplaints = [];
				this.complaintsTotalCount = 0;
			}

			this.complaintsTableLoading = false;
		},
		loadNextPage() {
			this.tablePage++;
			this.doSearch();
		},
	},
	mounted() {
		if (this.$route.query.searchTerm) {
			this.request.searchTerm = String(this.$route.query.searchTerm);
		}
		this.doSearch();
	},
	watch: {
		dateRange: {
			handler(val) {
				if (val && val.length === 2) {
					const { fromDate, toDate } = handleSearchDateRangeChange(val);
					this.request.fromDate = fromDate;
					this.request.toDate = toDate;
				} else {
					this.request.fromDate = null;
					this.request.toDate = null;
					this.selectedTimePeriod = [];
					this.timePeriodOptions.forEach((option: any) => (option.checked = false));
				}
			},
			deep: true,
		},
		request: {
			handler() {
				if (this.request.fromDate && this.request.toDate) {
					this.dateRange = [this.request.fromDate, this.request.toDate];
				}
			},
			deep: true,
		},
	},
});
</script>
